<script>
export default {
    name: "VisitReportPrint",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        Promise.allSettled([ this.fetchPatients(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {

            let url = `PatientsReports/GetAdmssionReport?dateFrom=${this.$route.query.dateFrom}&dateTo=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.admittedBy ? `&AdmittedBy=${this.$route.query.admittedBy}` : ``;
            url += this.$route.query.ward ? `&Ward=${this.$route.query.ward}` : ``;

            return this.$http.get(url).then(response => {
                        this.patients = response.data;
                    }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="flex-1 text-center my-2">
            <h5 class="font-medium uppercase">Admission Report</h5>
        </div>
        <table class="table table-hover">
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/6">Name</th>
                    <th class="p-tiny flex-1">IP No</th>
                    <th class="p-tiny flex-1">ID No</th>
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Time</th>
                    <th class="p-tiny flex-1">User</th>
                    <th class="p-tiny flex-1">Discharged</th>
                    <th class="p-tiny flex-1">Ward</th>
                    <th class="p-tiny flex-1">Bed</th>
                    <th class="p-tiny w-1/6">Diagnosis</th>
                    <th class="p-tiny w-1/6">Payment</th>
                    <th class="p-tiny flex-1">Report</th>
                </tr>
                <tr class="flex w-full" v-for="(patient, idx) in patients.patientAdmissionReport" :key="idx">
                          <td class="p-tiny w-1/6">{{ patient.names }}</td>
                          <td class="p-tiny flex-1">{{ patient.ipfileno }}</td>
                          <td class="p-tiny flex-1">{{ patient.nationalid }}</td>
                          <td class="p-tiny flex-1">{{ patient.dateAdmitted | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.timeAdmitted }}</td>
                          <td class="p-tiny flex-1">{{ patient.admittedBy }}</td>
                          <td class="p-tiny flex-1">{{ patient.discharged }}</td>
                          <td class="p-tiny flex-1">{{ patient.ward }}</td>
                          <td class="p-tiny flex-1">{{ patient.bed }}</td>
                          <td class="p-tiny w-1/6">{{ patient.memo }}</td>
                          <td class="p-tiny w-1/6">{{ patient.pMode }}</td>
                      </tr>
                <tr class="flex w-full">
                    <th class="p-tiny w-1/2"></th>
                    <th class="p-tiny w-1/2 text-right">Total Admissions: 
                      {{ patients.patientAdmissionReport ? patients.patientAdmissionReport.length : 0 }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</template>